module.exports = __webpack_public_path__ + "img/07.4d8a0adc.gif";